import { TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { NumericFormat } from 'react-number-format';

export default function QuizQuestionWorksheetAnswer(
    {answerIndex, answerCallback, initVal, fieldType}
)
{
    const [answerText, setAnswerText] = useState("");
    // Tracks the last value we sent to the parent. The parent stores it and
    // echoes it back as initVal on every re-render. We can tell these echoes
    // apart from genuine external changes (e.g. a new question loading) by
    // comparing: if initVal matches what we last sent, skip the update.
    const lastSentValue = useRef(undefined);

    useEffect(() => {
        if (initVal !== lastSentValue.current) {
            setAnswerText(initVal ?? "");
        }
    }, [initVal]);

    const updateAnswer = (event) => {
        lastSentValue.current = event.target.value;
        setAnswerText(event.target.value);
        answerCallback(answerIndex, event.target.value);
    };

    if (fieldType === "decimal")
        return <NumericFormat value={answerText} customInput={TextField} onChange={updateAnswer} decimalScale={2} fixedDecimalScale />;
    else if (fieldType === "integer")
        return <NumericFormat value={answerText} customInput={TextField} onChange={updateAnswer} decimalScale={0} />;
    else
        return <TextField onChange={updateAnswer} value={answerText} />;
}